import { DELETE_PROJECT_CHILDREN_OVERLAY } from "shared/context/overlay/types"
import { useEvent } from "shared/lib/useEvent"
import { useOverlay } from "shared/lib/useOverlay"
import { ProjectChild } from "shared/types/Project"
import { ProjectChildMultiActionCallbacks } from "shared/types/ProjectChild"

interface UseProjectChildMultiActionCallbacksArgs {
  projectID: string
  projectChildren: ProjectChild[]
  onAction?: () => void
}

export function useProjectChildMultiActionCallbacks({
  projectID,
  projectChildren
}: UseProjectChildMultiActionCallbacksArgs): ProjectChildMultiActionCallbacks {
  const { openOverlay } = useOverlay(DELETE_PROJECT_CHILDREN_OVERLAY)

  const handleDelete = useEvent(() => {
    openOverlay({ projectID, childrenToDelete: projectChildren })
  })

  return { onDelete: handleDelete }
}
